/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ link: NonNullable<unknown>, code: NonNullable<unknown> }} Planshare_Share_Text_LinkInputs */

const en_us2_planshare_share_text_link = /** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`My training plan on MyPocketGym: ${i?.link} (code ${i?.code})`)
};

const pt_br2_planshare_share_text_link = /** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu plano de treino no MyPocketGym: ${i?.link} (código ${i?.code})`)
};

const pt_pt2_planshare_share_text_link = /** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu plano de treino no MyPocketGym: ${i?.link} (código ${i?.code})`)
};

/** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */
const es_419_planshare_share_text_link = en_us2_planshare_share_text_link;

/** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */
const fr_fr2_planshare_share_text_link = en_us2_planshare_share_text_link;

/** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */
const de_de2_planshare_share_text_link = en_us2_planshare_share_text_link;

/** @type {(inputs: Planshare_Share_Text_LinkInputs) => LocalizedString} */
const it_it2_planshare_share_text_link = en_us2_planshare_share_text_link;

/**
* | output |
* | --- |
* | "My training plan on MyPocketGym: {link} (code {code})" |
*
* @param {Planshare_Share_Text_LinkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_share_text_link = /** @type {((inputs: Planshare_Share_Text_LinkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_Share_Text_LinkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_share_text_link(inputs)
	if (locale === "es-419") return es_419_planshare_share_text_link(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_share_text_link(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_share_text_link(inputs)
	if (locale === "de-DE") return de_de2_planshare_share_text_link(inputs)
	if (locale === "it-IT") return it_it2_planshare_share_text_link(inputs)
	return en_us2_planshare_share_text_link(inputs)
});
export { planshare_share_text_link as "planshare.share_text_link" }